import { getClient } from '../../api/config';
import { XHR } from '../../api/xhr';

export const END_POINTS = {
    login: '/api-admin/v1/oauth2/login',
    refresh: '/api-admin/v1/oauth2/refresh',
    reset: '/api-admin/v1/oauth2/passwords/reset',
};

const login = (email, password) => XHR.post(END_POINTS.login, {
    email, password, grant_type: 'Password', ...getClient(),
});

const refresh = (refresh_token) => XHR.post(END_POINTS.refresh, { refresh_token, ...getClient() });

const resetPassword = (validation_code, email, new_password) => XHR.post(END_POINTS.reset, { validation_code, email, new_password });

const createPassword = (validation_code, email, new_password) => XHR.post(END_POINTS.reset, { validation_code, email, new_password });

export {
    login, refresh, createPassword, resetPassword,
};
